import React from "react";
import { CaregiverCertification } from "../../../messages/ObjectIds";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import Flex from "../../Generic/Flex";
import Label from "../../Label";

interface Props {
  title: string;
  certifications: CaregiverCertification[];
}

const AvailableTaskListItemTitle = (props: Props) => {
  return (
    <Flex direction="row" alignItems="center" xGap={10}>
      <Label variant="filled" color="primary" uppercase={true}>
        {translate(STRINGS.TASK)}
      </Label>
      <div className="AvailableTasksListItem__Title">
        {props.title} ({props.certifications.join(", ")})
      </div>
    </Flex>
  );
};

export default AvailableTaskListItemTitle;
